import { Typography } from '@mui/material';

import { medium } from '@styles/fontWeights';

const SocialBoostModalContent = () => (
  <Typography variant="h5" component="p" fontWeight={medium} color="secondary">
    We'll post to our networks on Linkedin, Facebook, X, & Instagram, and share
    to any job groups in your area for
    <Typography variant="inherit" component="span" color="green" sx={{ ml: 1 }}>
      $10/boost
    </Typography>
  </Typography>
);

export default SocialBoostModalContent;
